export const START_LOAD = 'events/START_LOAD';
export const FINISH_LOAD = 'events/FINISH_LOAD';

const initialState = {
    loading:false,
    events:null
};
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case START_LOAD:  return {...state, loading:true};
        case FINISH_LOAD:  return {...state, loading:false, events:action.payload};
        default: return state;
    }
}